<style scoped>
#content {
  padding-top: 64px;
}
</style>

<template lang="pug">
    div
      app-delivery-bar(:fixed='true', :top='"64px"')
      .container#content
          .vspace.medium.hide-on-med-and-down
          .row
              //- .col.l2.fixed.hide-on-med-and-down
              //-     app-supplier-filter(
              //-       @onSearchByCity='onSearchByCity'
              //-       :selectedCity='selectedCity'
              //-     )
              //- .hide-on-large-only#filter-container
              //-     .vspace.small
              //-     a.btn.btn-flat(@click='showFilter') 
              //-         i.material-icons.left filter_list
              //-         | filters
              .col.s12
                  .row
                      p.subtitle.light(v-if='$route.query.name') Search results for "{{$route.query.name}}"
                  .row
                      app-supplier-card(v-for='(supplier, index) in suppliers', :shop='supplier', :index='index', :key='supplier.id')
                      p.subtitle.large.center-align(v-if='!suppliers.length') No items found
</template>
<script>
import AppDeliveryBar from '@/components/app-delivery-bar'
import AppSupplierCard from '@/components/app-supplier-card'
import AppSupplierFilter from '@/components/app-supplier-filter'
import axios from 'axios'

export default {
  meta: {
    title: 'Stores'
  },
  data () {
    return {
      suppliers: [],
      selectedCity: null
    }
  },
  components: {
    AppSupplierCard,
    AppDeliveryBar,
    AppSupplierFilter
  },
  created () {
    this.getSuppliers()
    this.selectedCity = this.$route.query.city
  },
  computed: {
    location () {
      return this.$store.state.cart.location
    }
  },
  watch: {
    location () {
      this.getSuppliers()
    }
  },
  methods: {
    showFilter () {
      const modalParams = {
        content: AppSupplierFilter,
        style: { fullscreen: true, padding: 'medium' },
        bind: {
          onSearchByCity: this.onSearchByCity,
          selectedCity: this.selectedCity
        }
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    onSearchByCity (city) {
      let query = {
        ...this.$route.query,
        city: city,
        includeShops: true
      }

      if (!city || city === 'all') {
        delete query['city']
        delete query['includeShops']
      }

      this.$router.push({path: this.$route.path, query: query})
    },
    getSuppliers () {
      axios
        .get(`${this.$config.API_URL}/shops`, {
          params: {
            location: this.location
          }
        })
        .then(result => {
          this.suppliers = result.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-suppliers.vue